import { motion } from 'framer-motion';
import bridalImg      from '../assets/IMG_0495.jpg';
import partyImg       from '../assets/IMG_0492.jpg';
import hairImg        from '../assets/IMG_0497.jpg';
import preBridalImg   from '../assets/IMG_0499.jpg';
import destinationImg from '../assets/IMG_0502.jpg';
import nailsImg       from '../assets/Nails/IMG_0513.jpg';
import styles from './Services.module.css';

// Skincare — Unsplash (no local skincare photo in assets)
const SKINCARE_IMG = 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=700&q=85';

const WA_BASE = 'https://wa.me/918890469900?text=Hi%2C%20I%27m%20interested%20in%20';
const WA_DEST = 'https://wa.me/918890469900?text=Hi%2C%20I%27m%20interested%20in%20destination%20bridal%20services%20from%20Shobha%20Salon';

const SERVICES = [
  {
    title: 'Bridal Makeup',
    desc: 'Complete bridal transformation tailored to your look, skin tone, and style. The most important day of your life deserves the most careful hands.',
    img: bridalImg,
    alt: 'Bridal makeup by Shobha Ma\'am — best bridal makeup artist in Bharatpur Rajasthan',
    waText: 'Bridal%20Makeup%20at%20Shobha%20Salon',
    featured: true,
  },
  {
    title: 'Party & Event Makeup',
    desc: 'Receptions, family functions, sangeets. Glam that lasts all night and photographs beautifully.',
    img: partyImg,
    alt: 'Party and event makeup — Shobha Salon Bharatpur',
    waText: 'Party%20%26%20Event%20Makeup%20at%20Shobha%20Salon',
  },
  {
    title: 'Hair Styling',
    desc: 'Blowouts, bridal updos, curls and more. Hair that truly completes the look.',
    img: hairImg,
    alt: 'Bridal hair styling and updo — Shobha Salon Bharatpur',
    waText: 'Hair%20Styling%20at%20Shobha%20Salon',
  },
  {
    title: 'Pre-Bridal Packages',
    desc: 'Complete pre-wedding care: skin prep, grooming, and consultation across multiple sessions.',
    img: preBridalImg,
    alt: 'Pre-bridal package at Shobha Beauty Parlour Bharatpur',
    waText: 'Pre-Bridal%20Package%20at%20Shobha%20Salon',
  },
];

function Card({ title, desc, img, alt, waText, index }) {
  return (
    <motion.div
      className={styles.card}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.75, delay: index * 0.1 }}
    >
      <div className={styles.cardImg}>
        <img src={img} alt={alt} loading="lazy" />
        <div className={styles.cardImgOverlay} />
      </div>
      <div className={styles.cardBody}>
        <h3 className={styles.cardTitle}>{title}</h3>
        <p className={styles.cardDesc}>{desc}</p>
        <a
          href={`${WA_BASE}${waText}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.cardCta}
        >
          Book Now →
        </a>
      </div>
    </motion.div>
  );
}

export default function Services() {
  return (
    <section id="services" className={styles.services}>
      <div className={styles.inner}>

        {/* Heading */}
        <motion.div
          className={styles.heading}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.7 }}
        >
          <span className={styles.headingTag}>What We Offer</span>
          <h2 className={styles.headingTitle}>Our Services</h2>
          <p className={styles.headingSub}>Every treatment. Exceptional results.</p>
        </motion.div>

        {/* Featured card — Bridal Makeup, full width tall */}
        <motion.div
          className={styles.featured}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9 }}
        >
          <div className={styles.featuredImg}>
            <img src={SERVICES[0].img} alt={SERVICES[0].alt} loading="lazy" />
            <div className={styles.featuredOverlay} />
          </div>
          <div className={styles.featuredContent}>
            <span className={styles.featuredBadge}>✦ Our Signature</span>
            <h3 className={styles.featuredTitle}>{SERVICES[0].title}</h3>
            <p className={styles.featuredDesc}>{SERVICES[0].desc}</p>
            <a
              href={`${WA_BASE}${SERVICES[0].waText}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.featuredCta}
            >
              Book Your Bridal →
            </a>
          </div>
        </motion.div>

        {/* Grid cards — remaining 3 services */}
        <div className={styles.grid}>
          {SERVICES.slice(1).map((s, i) => (
            <Card key={s.title} {...s} index={i} />
          ))}

          {/* Skincare card */}
          <Card
            title="Skincare &amp; Facials"
            desc="Trusted treatments for glowing, healthy skin. Customised for every skin type."
            img={SKINCARE_IMG}
            alt="Skincare and facial treatments at Shobha Salon Bharatpur"
            waText="Skincare%20%26%20Facials%20at%20Shobha%20Salon"
            index={3}
          />

          {/* Nail Art card */}
          <Card
            title="Nail Art & Extensions"
            desc="Bridal nail art, gel extensions and custom designs. The perfect finishing touch for your look."
            img={nailsImg}
            alt="Nail art and extensions at Shobha Salon Bharatpur — bridal nail designs"
            waText="Nail%20Art%20%26%20Extensions%20at%20Shobha%20Salon"
            index={4}
          />
        </div>

        {/* Destination card — full width */}
        <motion.div
          className={styles.destination}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9 }}
        >
          <div className={styles.destinationImg}>
            <img src={destinationImg} alt="Destination bridal wedding by Shobha Salon" loading="lazy" />
            <div className={styles.destinationOverlay} />
          </div>
          <div className={styles.destinationContent}>
            <span className={styles.destinationBadge}>Exclusive Service</span>
            <h3 className={styles.destinationTitle}>Destination Bridal</h3>
            <p className={styles.destinationDesc}>
              We travel to you. Hotels, palaces, resorts. Our team arrives fully equipped
              to deliver the same flawless results wherever your celebration takes place.
            </p>
            <p className={styles.venues}>
              Available on special request — we bring our full studio to your wedding venue, anywhere.
            </p>
            <a
              href={WA_DEST}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.destinationCta}
            >
              Plan Your Destination Bridal →
            </a>
          </div>
        </motion.div>

      </div>
    </section>
  );
}
